





















































































































































import { Component, Vue } from "vue-property-decorator";
import {
  AnswerWithSubQuestions,
  FailuresAccordion,
  FailuresCardQuestion,
  FailuresOptionCards,
  FailuresCondensedOptions,
  FailuresRootCauseList,
  FailuresRiskValue,
  Question2,
  RootCause
} from "@dsm/dsm-storybook";
import RiskPickerForm from "../views/RiskPickerForm.vue";
import { defaultQuestions } from "@/service/initial-data";
import {
  AnswerData,
  QuestionWithAnswers,
  RiskAnalysisData,
  RiskAnalysisItem,
  RootCauseParam,
  ReportData
} from "@/interfaces/questions";
import QuestionView from "@/views/Question.vue";
import Report from "@/views/Report.vue";
import { getFormDataFailureModes, getFormDataProjectPhases, getFormDataCauses, getSolution }  from "@/util/database";
import {answers} from "@dsm/dsm-storybook/src/components/advisor-progress/advisor-progress.stories";

const ROOT_CAUSE_TYPE = "root-cause";
const RISK_ANALYSIS_TYPE = "risk-analysis";
const REPORT_TYPE = "report";
const INVALID_INDEX = -1;
const FAILURE_QUESTION_INDEX = 1;
const PHASE_QUESTION_INDEX = 2;

@Component({
  components: {
    RiskPickerForm,
    FailuresOptionCards,
    FailuresCardQuestion,
    FailuresCondensedOptions,
    FailuresAccordion,
    FailuresRootCauseList,
    FailuresRiskValue,
    QuestionView,
    Report
  }
})
export default class MainForm extends Vue {
  activeQuestions: Array<Question2> = defaultQuestions;
  selectedRootCauses: Array<number> = [];
  calculatedRiskData: Array<number> = [];
  reportData: Array<ReportData> = [];
  indexOfRootCause = INVALID_INDEX;
  indexOfRiskAnalysis = INVALID_INDEX;
  indexOfReport = INVALID_INDEX;

  activeQuestionIndex = 0;
  questionWithAnswersLog: Array<QuestionWithAnswers<AnswerData | RootCause | RiskAnalysisData> | null> = [];

  mounted() {
    for (let i = 0; i < this.activeQuestions.length; i++) {
      this.questionWithAnswersLog.push(null);
    }
    this.activeQuestions[this.activeQuestionIndex].isActive = true;

    for (let i = 0; i < this.activeQuestions.length; i++) {
      if (this.activeQuestions[i].type === ROOT_CAUSE_TYPE) {
        this.indexOfRootCause = i;
      }
      if (this.activeQuestions[i].type === RISK_ANALYSIS_TYPE) {
        this.indexOfRiskAnalysis = i;
      }
      if (this.activeQuestions[i].type === REPORT_TYPE) {
        this.indexOfReport = i;
      }
    }
  }

  updated() {
    if (
      this.indexOfRootCause !== INVALID_INDEX &&
      this.indexOfRiskAnalysis !== INVALID_INDEX &&
      this.indexOfReport !== INVALID_INDEX
    ) {
      if (this.activeQuestionIndex == FAILURE_QUESTION_INDEX && this.questionWithAnswersLog[FAILURE_QUESTION_INDEX] == null) {
        this.activeQuestions[FAILURE_QUESTION_INDEX].answers = [];
        this.activeQuestions[FAILURE_QUESTION_INDEX].answers = this.mapAnswerWithSubQuestions(getFormDataFailureModes());
      } else if (this.activeQuestionIndex == PHASE_QUESTION_INDEX && this.questionWithAnswersLog[PHASE_QUESTION_INDEX] == null){
        this.activeQuestions[PHASE_QUESTION_INDEX].answers = [];
        const failureAnswerId = this.getSelectedFailureAnswerId();
        if (failureAnswerId != null) {
          this.activeQuestions[PHASE_QUESTION_INDEX].answers = this.mapAnswerWithSubQuestions(getFormDataProjectPhases(failureAnswerId));
        }
      } else if (this.activeQuestionIndex == this.indexOfRootCause && this.questionWithAnswersLog[this.indexOfRootCause] == null) {
        this.fetchRootCausesData(this.getParamsForRootCause());
      } else if (this.activeQuestionIndex == this.indexOfReport && this.questionWithAnswersLog[this.indexOfReport] == null) {
        this.fetchReportData(this.getParamsForRootCause(), this.getSelectedRootCauseIds())
        this.calculatedRiskData = this.calculateRiskAnalysis();
      }
    }
  }

  resetToQuestion(questionIndex: number) {
    this.activeQuestionIndex = questionIndex;

    this.activeQuestions.forEach((question, index) => {
      if (index >= questionIndex) {
        question.answers = [];
      }
    });

    this.questionWithAnswersLog.forEach((answer, index) => {
      if (answer) {
        if (index >= questionIndex) {
          this.questionWithAnswersLog[index] = null;
        }
      }
    });

    this.selectedRootCauses = [];
    this.scrollIntoView('accordion-' + (questionIndex + 1));
  }

  scrollIntoView(id: string) {
    const el = document.getElementById(id);
    if (el) {
      setTimeout(function() {
        el.scrollIntoView({behavior: "smooth", block: "start"});
      }, 250);
    }
  }

  mapAnswerWithSubQuestions(data: Array<any>): AnswerWithSubQuestions[] {
    return data.map(
      item => {
      return {
        id: item.id,
        value: item.value,
        i18nDescription: item.i18nDescription,
        i18nDescriptionText: item.i18nDescriptionText,
        imgUrl: item.imgUrl,
        isSelected: false,
        subQuestions: (item.subQuestions as Array<any>).map(item => {
          return {
            type: "question-view",
            id: item.id,
            questionNumber: item.questionNumber,
            i18nQuestion: item.i18nQuestion,
            answers: this.mapAnswerWithSubQuestions(item.answers),
            refine: false,
            isActive: false,
            parent: null
          } as Question2;
        })
      } as AnswerWithSubQuestions;
    }
    )
  }

  hasAnyOfAnswers(answers: AnswerWithSubQuestions[]) {
    return answers.filter(answer => answer.isSelected).length > 0;
  }

  getRiskAnalysisData(index: number) {
    return this.questionWithAnswersLog[index] as QuestionWithAnswers<RiskAnalysisData>;
  }

  // TODO: UPDATE THIS FUNCTION BY REMOVING RETURN OF RootCauseParam AND RETURN JUST ROOT_CAUSE BECAUSE FUNCTION FOR ANOTHER DATA IS AVAILABLE
  getParamsForRootCause() {
    const failureQuestionLog = this
      .questionWithAnswersLog[1] as QuestionWithAnswers<AnswerData>;
    const projectPhaseQuestionLog = this.questionWithAnswersLog[2] as QuestionWithAnswers<AnswerData>;

    if (failureQuestionLog !== null && projectPhaseQuestionLog != null) {
      const failureAnswer = failureQuestionLog?.subQuestions.length > 0
        ? failureQuestionLog?.subQuestions[failureQuestionLog?.subQuestions.length - 1].answers
          .filter(item => item.isSelected)[0].id
        : failureQuestionLog.answers.filter(item => item.isSelected)[0].id;
      const projectPhase = projectPhaseQuestionLog.answers.filter(
        item => item.isSelected
      )[0].id;

      return {
        failureAnswerId: failureAnswer,
        projectPhaseId: projectPhase
      } as RootCauseParam;
    }
    return null;
  }

  getSelectedFailureAnswerId() {
    const failureQuestionLog = this
      .questionWithAnswersLog[1] as QuestionWithAnswers<AnswerData>;

    if (failureQuestionLog !== null) {
      const failureAnswer = failureQuestionLog?.subQuestions.length > 0
        ? failureQuestionLog?.subQuestions[failureQuestionLog?.subQuestions.length - 1].answers
          .filter(item => item.isSelected)[0].id
        : failureQuestionLog.answers.filter(item => item.isSelected)[0].id;

      return failureAnswer;
    }
    return null;
  }

  getSelectedRootCauseIds() {
    const rootCauses = this.questionWithAnswersLog[this.indexOfRootCause] as QuestionWithAnswers<RootCause>
    if (rootCauses != null) {
      return rootCauses.answers
        .filter(item => item.isSelected)
    }
    return null;
  }

  // TODO: GET DATA FOR ROOT CAUSES
  fetchRootCausesData(data: RootCauseParam | null) {
    if (data != null) {
      const rootCauses = getFormDataCauses(data.failureAnswerId, data.projectPhaseId).map(item => {
        return {
          id: item.id,
          name: item.name,
          phase: item.phase,
          isSelected: false,
        } as RootCause;
      });

      this.activeQuestions[this.indexOfRootCause].answers = rootCauses;
    };
  }

  fetchReportData(data: RootCauseParam | null, routeCauses: RootCause[] | null) {
    const failureName = (this.activeQuestions[1].answers as Array<AnswerWithSubQuestions>).filter(item => item.isSelected);
    if (data != null && routeCauses != null && routeCauses.length > 0) {
      this.reportData = [];
      routeCauses.forEach(rootCause => {
        this.reportData.push({
          mitigations: getSolution(data.failureAnswerId, rootCause.id),
          rootCoosTitle: rootCause.name,
          phase: rootCause.phase,
          failure: failureName[0].i18nDescription,
        } as ReportData);
      });
    }
    this.calculateRiskAnalysis();
  }

  getRiskAnalysisRequestParams() {
    return this.questionWithAnswersLog[this.indexOfRiskAnalysis]?.answers;
  }

  getAnswerSelectedIndexes(
    questionWithAnswers: QuestionWithAnswers<AnswerData | RootCause>
  ) {
    const array: Array<number> = [];
    if (questionWithAnswers.answers !== undefined) {
      for (let i = 0; i < questionWithAnswers.answers.length; i++) {
        if (questionWithAnswers.answers[i].isSelected) {
          array.push(i);
        }
      }
    }
    return array;
  }

  onAnswer(answer: AnswerWithSubQuestions, question: Question2) {
    const questionWithAnswers = {
      type: question.type,
      questionNumber: question.questionNumber,
      question: question.i18nQuestion,
      answers: (question.answers as AnswerWithSubQuestions[]).map(item =>
        this.answerDataFromAnswerWithSubQuestions(item)
      ),
      subQuestions: [],
      questionRef: question
    } as QuestionWithAnswers<AnswerData>;

    if (this.questionWithAnswersLog[this.activeQuestionIndex] !== null) {
      const item = this.questionWithAnswersLog[
        this.activeQuestionIndex
      ] as QuestionWithAnswers<AnswerData>;
      item.subQuestions.push(questionWithAnswers);
      Vue.set(this.questionWithAnswersLog, this.activeQuestionIndex, item);
    } else {
      Vue.set(
        this.questionWithAnswersLog,
        this.activeQuestionIndex,
        questionWithAnswers
      );
    }
  }

  onRootCausesCompleted() {
    const answers = this.activeQuestions[this.activeQuestionIndex]
      .answers as Array<RootCause>;

    const questionWithAnswers = {
      type: ROOT_CAUSE_TYPE,
      questionNumber: "",
      question: "",
      answers: answers,
      subQuestions: [],
      questionRef: null
    } as QuestionWithAnswers<RootCause>;

    if (this.questionWithAnswersLog[this.indexOfRiskAnalysis] !== questionWithAnswers) {
      this.questionWithAnswersLog[this.indexOfRiskAnalysis] = null;
    }

    this.questionWithAnswersLog[this.activeQuestionIndex] = questionWithAnswers;
    this.activeQuestionIndex++;
  }

  onQuestionCompleted() {
    this.activeQuestionIndex++;
  }

  optionClicked(
    questionWithAnswers: QuestionWithAnswers<AnswerData | RootCause>,
    questionIndex: number,
    subQuestionIndex: number,
    index: number
  ) {
    function cleanAnswers(answers: AnswerWithSubQuestions[]) {
      answers.forEach(answer => {
        answer.isSelected = false;
        answer.subQuestions.forEach(subQuestion =>
          cleanAnswers(subQuestion.answers as AnswerWithSubQuestions[])
        );
      });
    }

    if (this.activeQuestions[questionIndex].type == "root-cause") {
      this.activeQuestionIndex = questionIndex;
    } else if (this.activeQuestions[questionIndex].type == "risk-analysis") {
      this.activeQuestionIndex = questionIndex;
    } else {
      const questionRef = questionWithAnswers.questionRef;

      if (questionRef != null) {
        cleanAnswers(questionRef.answers as AnswerWithSubQuestions[]);
        if (questionWithAnswers.subQuestions.length > 0) {
          this.activeQuestionIndex = questionIndex;
        }
        const logItem = this.questionWithAnswersLog[
          questionIndex
        ] as QuestionWithAnswers<AnswerData>;

        if (logItem != null) {
          if (logItem.subQuestions.length > subQuestionIndex + 1) {
            logItem.subQuestions.splice(
              subQuestionIndex + 1,
              logItem.subQuestions.length - (subQuestionIndex + 1)
            );
            this.activeQuestionIndex = questionIndex;
          }
          questionRef.answers[index].isSelected = true;

          questionWithAnswers.answers.forEach(item => {
            if (item === questionWithAnswers.answers[index]) {
              item.isSelected = true;
            } else {
              item.isSelected = false;
            }
          });

          questionWithAnswers.subQuestions = [];
          this.calculatedRiskData = [];
          this.clearRootCauses()
          for (let i = questionIndex + 1; i < this.activeQuestions.length; i++) {
            Vue.set(this.questionWithAnswersLog, i, null);
          }

          if (
            (questionRef.answers[index] as AnswerWithSubQuestions).subQuestions.length == 0
          ) {
            this.activeQuestionIndex = questionIndex + 1;
          } else {
            this.activeQuestionIndex = questionIndex;
          }
        }
      }
    }
  }

  clearRootCauses() {
    this.selectedRootCauses = [];
    if (this.activeQuestions[this.indexOfRootCause] != null) {
      (this.activeQuestions[this.indexOfRootCause].answers as RootCause[])
        .forEach(item => item.isSelected = false);
    }
  }

  onRootCauseSelected(selectedIndex: number) {
    if (this.selectedRootCauses.includes(selectedIndex)) {
      this.selectedRootCauses.splice(
        this.selectedRootCauses.indexOf(selectedIndex),
        1
      );

      this.calculatedRiskData = [];
      Vue.set(this.questionWithAnswersLog, this.indexOfRiskAnalysis, null);

    } else {
      this.selectedRootCauses.push(selectedIndex);

      this.calculatedRiskData = [];
      Vue.set(this.questionWithAnswersLog, this.indexOfRiskAnalysis, null);
    }

    if (this.questionWithAnswersLog[this.indexOfRootCause] !== null) {
      const rootCauseAnswers = (this.questionWithAnswersLog[this.indexOfRootCause] as QuestionWithAnswers<RootCause>).answers
      for (let i = 0; i < rootCauseAnswers.length; i++) {
        rootCauseAnswers[i].isSelected = false;
      }
    }
  }

  onRiskAnalysisCompleted(riskAnalysisItems: RiskAnalysisItem[]) {
    const rootCausesSelectedAnswers = (this.activeQuestions[this.indexOfRootCause].answers as Array<RootCause>)
      .filter(item => item.isSelected);

    const riskAnalysisData: Array<RiskAnalysisData> = [];
    for (let i = 0; i< riskAnalysisItems.length; i++) {
      riskAnalysisData.push(
        {
          question: rootCausesSelectedAnswers[i].name,
          result: riskAnalysisItems[i]
        } as RiskAnalysisData
      )
    }

    this.questionWithAnswersLog[this.activeQuestionIndex] = {
      type: "risk-analysis",
      questionNumber: this.activeQuestions[this.activeQuestionIndex].questionNumber,
      question: this.activeQuestions[this.activeQuestionIndex].i18nQuestion,
      answers: riskAnalysisData,
      questionRef: null,
      subQuestions: []
    } as QuestionWithAnswers<RiskAnalysisData>;

    this.activeQuestionIndex++;
  }

  calculateRiskAnalysis() {
    return (this.questionWithAnswersLog[this.indexOfRiskAnalysis]?.answers as RiskAnalysisData[])
      .map(item => Math.max(
          item.result.severity == 3 ? 100 : 0,
          item.result.severity == 4 ? 125 : 0,
          ((4 - item.result.detectability) + 1) * (item.result.probability + 1) * (item.result.severity + 1 )
        ));
  }

  answerDataFromAnswerWithSubQuestions(
    answerWithSubQuestions: AnswerWithSubQuestions
  ) {
    return {
      id: answerWithSubQuestions.id,
      name: answerWithSubQuestions.i18nDescription,
      isSelected: answerWithSubQuestions.isSelected
    } as AnswerData;
  }

  // General navigation
  toggleStep(index: number) {
    const isCurrentItemActive = this.activeQuestions[index].isActive;
    if (!isCurrentItemActive) {
      for (let i = 0; i < this.activeQuestions.length; i++) {
        this.activeQuestions[i].isActive = false;
      }
    }

    this.activeQuestions[index].isActive = !this.activeQuestions[index]
      .isActive;
    this.activeQuestionIndex = index;
  }
}
